export const getLocationParams = (params) => {
    const locationParams = new URLSearchParams(params);
    locationParams.delete("baseOfferToken");
    return locationParams;
};
export const getVisibleFlights = (flights) => flights.filter((flight) => !flight.isHidden);
